module.exports = __webpack_public_path__ + "img/grafic-pie.ce921771.png";